import { render, staticRenderFns } from "./OutcomePanel.vue?vue&type=template&id=21279989&"
import script from "./OutcomePanel.vue?vue&type=script&lang=js&"
export * from "./OutcomePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports